export const rentalQuantities = [
  $localize`One`,
  $localize`Two`,
  $localize`Three`,
  $localize`Four`,
  $localize`Five`,
  $localize`Six`,
  $localize`Seven`,
  $localize`Eight`,
  $localize`Nine`,
  $localize`Ten`,
  $localize`Eleven`,
  $localize`Twelve`,
  $localize`Thirteen`,
  $localize`Fourteen`,
  $localize`Fifteen`,
  $localize`Sixteen`,
  $localize`Seventeen`,
  $localize`Eighteen`,
  $localize`Nineteen`,
  $localize`Twenty`,
  $localize`Twenty One`,
  $localize`Twenty Two`,
  $localize`Twenty Three`,
  $localize`Twenty Four`,
]
